const createResumeNotificationsState = (state, payload) => {
  const canUpdate = state.isPause && state.priority === payload.priority;

  if (canUpdate) {
    return {
      isPause: false,
      priority: 1
    };
  }

  return state;
};

export default createResumeNotificationsState;
